import { ReactNode } from 'react'
import { clsx } from 'clsx'
import { motion } from 'framer-motion'

interface CardProps {
  variant?: 'default' | 'glass' | 'gradient' | 'outlined'
  hover?: boolean
  padding?: 'sm' | 'md' | 'lg'
  children: ReactNode
  className?: string
  onClick?: () => void
}

export const Card = ({
  className,
  variant = 'default',
  hover = false,
  padding = 'md',
  children,
  onClick,
}: CardProps) => {
  const variants = {
    default: 'bg-white shadow-metallic border border-metallic-100',
    glass: 'glass shadow-glass',
    gradient: 'bg-gradient-to-br from-primary-50 to-white border border-primary-100',
    outlined: 'bg-white border-2 border-metallic-200',
  }

  const paddings = {
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8',
  }

  return (
    <motion.div
      whileHover={hover ? { y: -4, scale: 1.01 } : undefined}
      onClick={onClick}
      className={clsx(
        'rounded-2xl transition-all duration-300',
        variants[variant],
        paddings[padding],
        hover && 'cursor-pointer hover:shadow-metallic-lg',
        className
      )}
    >
      {children}
    </motion.div>
  )
}
